<script setup lang="ts">
  import { computed, onMounted, ref, nextTick, watch } from 'vue'
  import SettingsPage from '@/components/app/settings/SettingsPage.vue'
  import { usePlaceholderStore } from '@/shared/stores/placeholderStore'

  const { fetchPlaceholders } = usePlaceholderStore()
  const placeholders = computed(() => usePlaceholderStore().placeholders)

  onMounted(async () => {
    if (!placeholders.value || !placeholders.value.length > 0) {
      await fetchPlaceholders()
    }
  })

  // Function to handle iframe resizing based on its content
  const resizeIframe = (iframe) => {
    try {
      // Get the content height from the iframe's document body
      const iframeDocument = iframe.contentWindow.document
      const newHeight = iframeDocument.body.scrollHeight
      iframe.style.height = `${newHeight + 20}px`
    } catch (error) {
      console.error('Error resizing iframe:', error)
    }
  }
</script>

<template>
  <SettingsPage v-if="placeholders && placeholders.length > 0">
    <div class="mb-3 block font-medium">Platzhalter</div>
    <p class="mb-4 text-sm text-gray-700">
      Platzhalter in JUPUS ermöglichen das automatische Einfügen von personalisierten Daten in
      E-Mail-Vorlagen. Sie werden beim Erstellen einer E-Mail eingefügt und beim Versenden durch die
      passenden Informationen, wie z.B. den Namen des Mandanten oder die Signatur des
      Sachbearbeiters, ersetzt.
    </p>
    <p class="mb-4 text-sm text-gray-700">
      Kontextabhängige Platzhalter sind nur dann für Vorlagen verfügbar, wenn sie im Kontext der
      E-Mail Sinn ergeben, wie z.B. bei der Mandatsaufnahme für die Direktlinks zu Fragebögen und
      Dokumenten. Diese dynamischen Bausteine erleichtern die Kommunikation, indem sie manuelle
      Anpassungen unnötig machen.
    </p>
    <div class="mb-3 block font-medium">Verfügbare Platzhalter</div>
    <p class="mb-4 text-sm text-gray-700">
      Hier finden Sie eine Übersicht aller verfügbarer Platzhalter und deren Beschreibung. Bei
      kontextabhängigen Platzhaltern wird ein Beispiel angezeigt, wie der Platzhalter in einer
      E-Mail-Vorlage aussehen könnte.
    </p>
    <div
      v-for="placeholder in placeholders"
      :key="placeholder.key"
      class="pb-5"
    >
      <div
        v-html="placeholder.html"
        class="pb-2"
      ></div>
      <div class="text-sm text-gray-600">
        <span class="text-gray-900">
          {{ placeholder.description }}
        </span>
        <div v-if="placeholder.is_context_aware">
          <div class="font-weight-bold pt-3 text-gray-950">Beispiel</div>
          <iframe
            v-if="placeholder.is_context_aware"
            :srcdoc="placeholder.rendered_demo_context_html"
            frameborder="0"
            width="100%"
            ref="iframe"
            @load="resizeIframe($event.target)"
            style="border: none; width: 100%; overflow: hidden"
          ></iframe>
        </div>
      </div>
    </div>
  </SettingsPage>
</template>
